import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.NonWarrantyPricePoint.ChangedPricesFromExcel.IRequest;
type Headers = Api.Core.NonWarrantyPricePoint.ChangedPricesFromExcel.IHeaders;
type Response = Api.Core.NonWarrantyPricePoint.ChangedPricesFromExcel.IResponse;
const url = '/api/ProductManagement/NonWarrantyPricePoint/ChangedPricesFromExcel/:productId';
export async function nonWarrantyPricePointChangedPricesFromExcelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    body,
    url: createPathFromRoute(url, { productId: body.productId }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
